import { TYPOGRAPHY } from "@tKgpco/theme/design";
import { buttonBaseStyles } from "@tKgpco/theme/mixins";

const buttonType = {
    solid: "solid",
    outline: "outline",
    tertiary: "tertiary",
};

const baseProps = {
    hoverMode: "darken",
    activeMode: "darken",
    sizeVariant: "medium",
    typographyProps: {
        weight: TYPOGRAPHY.weight.black,
        size: "16px",
    },
    shape: "rounded",
    css: buttonBaseStyles(buttonType.solid),
};

export default {
    primary: {
        ...baseProps,
        color: "primary",
        buttonType: buttonType.solid,
        css: buttonBaseStyles(buttonType.solid),
    },
    secondary: {
        ...baseProps,
        color: "secondary",
        buttonType: buttonType.solid,
        css: buttonBaseStyles(buttonType.solid),
    },
    tertiary: {
        ...baseProps,
        color: "text.main",
        buttonType: buttonType.solid,
        css: buttonBaseStyles(buttonType.tertiary),
    },
    defaultProps: {
        css: buttonBaseStyles(buttonType.solid),
    },
};
